export const getColorForUserName = (name: string) => {
  const letters = "0123456789ABCDEF";
  const values = [0, 0, 0, 0, 0, 0];

  for (let i = 0; i < name.length; i++) {
    values[i % 6] = (values[i % 6] + name.charCodeAt(i)) % 16;
  }

  return "#" + values.map((v) => letters[v]).join("");
};
